export default __webpack_public_path__ + "static/media/ChariotIcon.6818fdae.png";